<template>
  <div class="page_underGuarantee">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="topForm">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="项目" size="small">
              <el-select v-model="listQuery.Projectid" placeholder="" value-key="Projectid" size="small" clearable filterable style="width:180px">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" size="small">
              <el-input v-model="listQuery.InsuredCardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="是否超龄" size="small">
              <el-select v-model="listQuery.SuperYear" placeholder="" clearable style="width:180px">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保障方案" size="small">
              <el-input v-model="listQuery.InsuranceCode" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
            <!-- <el-form-item label="归属月" size="small">
              <el-select v-model="listQuery.name" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item,index) in 12" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" class="re_down_form">
          <el-form-item label="疑似超龄" size="small" label-width="122px">
            <el-select v-model="listQuery.NextMonthSuperYear" placeholder="" clearable style="width:180px">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="劳动合同公司" size="small">
            <el-input v-model="listQuery.LaborContractUnit" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="申请开始时间">
            <el-date-picker type="date" placeholder="" v-model="listQuery.BeginTime" value-format="yyyy-MM-dd" style="width:180px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="申请结束时间">
            <el-date-picker type="date" placeholder="" v-model="listQuery.endTime" value-format="yyyy-MM-dd" style="width:180px" size="small"></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>申报端</el-breadcrumb-item> -->
          <el-breadcrumb-item>在保人员</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name" @changeType="changeType"></tabs>
      </div>
      <div class="ftabs">
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-preventReClick @click="expList()">&nbsp;导出列表</el-button>
          <el-popconfirm :title="'请确认是否给勾选中的 ' + multipleSelection.length + ' 人办理商保报减？'" @confirm="reduction()" style="margin:0 10px">
            <el-button type="warning" slot="reference" size="small" v-preventReClick :loading="isBtnLoading">&nbsp;报减</el-button>
          </el-popconfirm>
          <el-button type="success" @click="impAllocate" size="small" v-preventReClick :loading="isBtnLoading" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser' || userid=='9c895257-5e33-4888-9bd8-adb6df000066'">&nbsp;导入分摊基础数据</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" v-loading="loading" :row-class-name="tableRowClassName" style="width:100%">
          <!-- <el-table-column prop="BatchNum" label="投保批次号" width="90px" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column> -->
          <el-table-column type="selection" width="40" fixed="left">
          </el-table-column>
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column label="子项目" :show-overflow-tooltip="true" align="center" width="100">
            <template slot-scope={row}>{{ '' }}</template>
          </el-table-column>
          <el-table-column prop="InsuredCardId" label="证件号码" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="InsuredName" label="员工姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="age" label="年龄" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ getAge(row.InsuredCardId) }}</template>
          </el-table-column>
          <el-table-column prop="InsuredPhone" label="手机号码" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <!-- <el-table-column prop="Service" label="部门/客服" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="InsuranceName" label="险种" :show-overflow-tooltip="true" align="center" width="130">
          </el-table-column>
          <el-table-column prop="CreateTime" label="申请日期" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="LaborContractUnit" label="劳动合同公司" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="JobClasss" label="保费" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ '' }}</template>
          </el-table-column>
          <el-table-column prop="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="Remark1" label="备注1" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark2" label="备注2" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark3" label="备注3" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="Status" label="人员状态" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column prop="IsSuperYear" label="是否超龄" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column prop="OperationalSource" label="来源" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="120px">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <!-- <el-button type="text" v-preventReClick @click="showDeclare = true">报减</el-button> -->
                <el-button type="text" v-preventReClick @click="editPhone(row)">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="showEditPhone" width="700px">
      <el-form :model="phoneForm" :inline="true" label-width="100px">
        <el-form-item label="姓名">
          <el-input v-model="phoneName" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input type="number" v-model="phoneForm.InsuredPhone" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" v-if="IsEditProject">
          <el-select v-model="phoneForm.ProjectId" placeholder="" value-key="Projectid" size="small" style="width:200px" clearable filterable>
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工属性" prop="Attribute">
          <el-select v-model="phoneForm.Attribute" placeholder="" clearable size="small" style="width:200px">
            <el-option value="长期工"></el-option>
            <el-option value="临时工"></el-option>
            <el-option value="日结工"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="phoneForm.Remark" style="width:200px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditPhone = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditPhone" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="showWarnMsg" width="700px">
      <div v-html="warnMsg">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWarnMsg = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="allocateVisible" width="500px" class="res_dialog enter_dialog">
      <el-form class="" label-width="100px" size="small">
        <el-form-item label="导入Excel" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allocateVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/examineTabs.vue";
  export default {
    components: {
      tabs
    },
    data() {
      return {
        name: '/underGuarantee2',
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          InsuranceId: '',
          SuperYear: '',
          NextMonthSuperYear: '',
          InsuredCardId: '', //身份证
          InsuredName: '',
          InsuranceCode: '',
          BeginTime: '',
          endTime: '',
          Projectid: '', //项目
          LaborContractUnit: '', //劳动合同公司
        },
        totalCount: 0,
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        proNameList: [], //项目列表
        loading: false,
        tableData: [],
        showDeclare: false, //增/减员弹窗
        showBatchDeclare: false, //批量增减员弹窗
        showEditPhone: false, //修改手机号弹窗
        phoneName: '', //修改手机号姓名
        IsEditProject: false, //是否可以修改项目
        phoneForm: {
          Id: '',
          InsuredPhone: '',
          ProjectId: '',
          Attribute: '', //员工属性
          Remark: '',
        },
        multipleSelection: [],
        isBtnLoading: false,
        warnMsg: '',
        showWarnMsg: false,
        allocateVisible: false,
        fileList: [],
        fileUrl: '',
        userid: Cookies.get("userid-b")
      }
    },
    created() {
      this.getProList();
      this.getInsuredPersonsList();
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.getInsuredPersonsList();
      },
      handleClick() {},
      //切换增/减员状态
      changeType(val) {
        this.type = val;
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //下载模板
      downImportTemp() {},
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            console.log(res)
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
      //获取在保人员
      getInsuredPersonsList() {
        xz.getInsuredPersonsList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.List;
            this.totalCount = res.data.Count;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
            this.tableData = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getInsuredPersonsList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getInsuredPersonsList();
      },
      //导出列表
      expList() {
        this.loading = true;
        let data = {
          InsuredCardId: this.listQuery.InsuredCardId, //身份证
          InsuredName: '',
          Projectid: this.listQuery.Projectid, //项目
          LaborContractUnit: this.listQuery.LaborContractUnit, //劳动合同公司
          IsExport: '1',
          pageNum: 1,
          pageSize: 10000000
        }
        xz.getInsuredPersonsList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            aLink.download = '在保人员.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //修改手机号码
      editPhone(row) {
        this.phoneName = row.InsuredName;
        this.IsEditProject = row.IsEditProject;
        this.phoneForm = {
          Id: row.Id,
          InsuredPhone: row.InsuredPhone,
          ProjectId: row.Projectid,
          Attribute: row.EmployeeAttribute,
          Remark: row.Remark1
        }
        this.showEditPhone = true;
      },
      confirmEditPhone() {
        if (!this.phoneForm.InsuredPhone) {
          this.$message.warning('请填写手机号')
        } else if (this.phoneForm.InsuredPhone.length != 11) {
          this.$message.warning('请填写正确的手机号')
        } else {
          xz.updataPhoneIninsurance(this.phoneForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('修改成功！')
              this.showEditPhone = false;
              this.getInsuredPersonsList();
            } else {
              this.showEditPhone = false;
              this.$message.error('系统出错')
            }
          })
        }
      },
      getAge(idcard) {
        //获取年龄
        let myDate = new Date();
        let iden = idcard;
        let age = 0;
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        ) {
          age++;
        }
        return age
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //清空
      resetHandle() {
        this.listQuery = {
          pageNum: 1,
          pageSize: 10,
          InsuranceId: '',
          SuperYear: '',
          NextMonthSuperYear: '',
          InsuranceCode: '',
          InsuredCardId: '', //身份证
          InsuredName: '',
          Projectid: '', //项目
          LaborContractUnit: '', //劳动合同公司
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      reduction() {
        if (!this.isBtnLoading) {
          if (this.multipleSelection.length > 0 && !this.isBtnLoading) {
            this.isBtnLoading = true;
            let arr = [];
            this.multipleSelection.forEach(element => {
              let d = {
                Id: element.Id,
                ProjectName: element.ProjectName
              }
              arr.push(d)
            });
            xz.ReportReduce(arr, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('报减成功！');
                this.getInsuredPersonsList();
                this.isBtnLoading = false;
                if (res.warnMsg) {
                  this.warnMsg = res.warnMsg;
                  this.showWarnMsg = true;
                }
              } else {
                this.getInsuredPersonsList();
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        }
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.IsSuperYear == '是') {
          return 'warning-row';
        } else {
          return '';
        }
      },
      impAllocate() {
        this.allocateVisible = true;
        this.fileList = [];
        this.fileUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileUrl = res;
          } else {
            this.fileUrl = ''
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20260612154109608.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "商保项目分摊导入模版.xlsx";
        aTag.click();
      },
      confirmUpload() {
        if (this.fileUrl) {
          this.isBtnLoading = true;
          xz.importAllocatePer(this.fileUrl, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！')
              this.getInsuredPersonsList();
              this.fileUrl = '';
              this.fileList = [];
              this.allocateVisible = false;
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg)
              this.isBtnLoading = false;
            }

          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon {
    height: 32px;
    line-height: 32px;
    margin-left: 10px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_underGuarantee .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_underGuarantee .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_underGuarantee .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_underGuarantee .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_underGuarantee .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  /* .page_underGuarantee .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_underGuarantee .declareForm .el-form-item__error {
    top: 34px;
  } */
  .page_underGuarantee .el-table .warning-row {
    background: rgb(255, 199, 206);
  }
</style>